export default __webpack_public_path__ + "static/media/MerchantPartner.8d23abce.png";